module.exports = __webpack_public_path__ + "img/4Y5.6494385a.png";